import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Reveal, shot } from './primitives';

const CARDS = [
  { id: 'crm', image: 'card-crm', imageClass: 'mx-auto w-full max-w-[368px]' },
  { id: 'projects', image: 'card-projects', imageClass: 'mx-auto w-full max-w-[368px]' },
  { id: 'finance', image: 'card-finance', imageClass: 'w-[150%] max-w-none sm:w-[110%] md:mx-auto md:w-[80%] lg:mx-0 lg:w-[150%]' }
];

export default function PlatformOverview() {
  const { t, i18n } = useTranslation();

  return (
    <section id="platform" className="scroll-mt-20 pb-[72px] lg:pb-24" aria-labelledby="platform-title">
      <Container>
        <h2 id="platform-title" className="sr-only">
          {t('landing.platform.title')}
        </h2>
        <div className="grid gap-6 lg:grid-cols-3">
          {CARDS.map(({ id, image, imageClass }, index) => {
            const img = shot(image, i18n.language);
            return (
              <Reveal key={id} delay={index * 90} className="lp-card flex flex-col">
                <div className="px-7 py-8 sm:px-10 lg:px-9 lg:py-9 xl:px-12">
                  <h3 className="lp-h3">{t(`landing.platform.${id}.title`)}</h3>
                  <p className="lp-body mt-3">{t(`landing.platform.${id}.description`)}</p>
                </div>
                <div className="relative mt-auto h-[280px] overflow-hidden bg-sand-200 px-7 pt-8 sm:h-[340px] sm:px-10 lg:h-[355px] lg:px-9 lg:pt-9">
                  <img
                    src={img.src}
                    width={img.width}
                    height={img.height}
                    alt={t(`landing.platform.${id}.alt`)}
                    loading="lazy"
                    decoding="async"
                    className={`lp-shot rounded-b-none ${imageClass}`}
                  />
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </section>
  );
}
